module.exports = __webpack_public_path__ + "static/img/chanta (22).940ad89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chanta/chanta (22).jpg
// module id = 4rWT
// module chunks = 0